if (!customElements.get('ugc-block')) {
    class UGCBlock extends HTMLElement {
        constructor() {
            super();

            this.collapsibleRegion = this.querySelector('.ugc-caption');
            this.collapsibleContent = this.collapsibleRegion.querySelector('p');
            this.readMoreButton = this.querySelector('.read-more--button');
            this.maxHeight = parseInt(this.dataset.maxHeight);
        }

        connectedCallback() {
            this.debounceTruncateRegion = window.debounce(this.truncateRegion.bind(this), 100);
            window.addEventListener('resize', this.debounceTruncateRegion.bind(this));
            this.truncateRegion();

            this.readMoreButton.addEventListener('click', this.onButtonClick.bind(this));
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this.debounceTruncateRegion);
        }

        onButtonClick() {
            this.collapsibleRegion.classList.toggle('expanded');
            this.readMoreButton.setAttribute(
                'aria-expanded',
                this.collapsibleRegion.classList.contains('expanded') ? true : false
            );
        }

        truncateRegion() {
            if (this.collapsibleContent.offsetHeight > this.maxHeight) {
                this.collapsibleRegion.classList.add('has-more-lines');
            } else {
                this.collapsibleRegion.classList.remove('has-more-lines');
            }
        }
    }
    customElements.define('ugc-block', UGCBlock);
}
